<template>
  <div id="app">
    <form>
      <fieldset>
        <div class="row responsive-label">
          <div class="col-sm-12 col-md-3">
            <label for="fileName">File Name</label>
          </div>
          <div class="col-sm-12 col-md">
            <input v-model="fileName" type="text" id="fileName"/>
          </div>
        </div>
        <div class="row responsive-label">
          <div class="col-sm-12 col-md-3">
            <label for="certPrefix">Certificate Prefix</label>
          </div>
          <div class="col-sm-12 col-md">
            <input v-model="certPrefix" type="text" id="certPrefix"/>
          </div>
        </div>
        <div class="row responsive-label">
          <div class="col-sm-12 col-md-3">
            <label for="certStart">Certificate Starting Number</label>
          </div>
          <div class="col-sm-12 col-md">
            <input v-model="certStart" type="text" id="certStart"/>
          </div>
        </div>
        <div class="row responsive-label">
          <div class="col-sm-12 col-md-3">
            <label for="wsPrefix">Worksheet Prefix</label>
          </div>
          <div class="col-sm-12 col-md">
            <input v-model="wsPrefix" type="text" id="wsPrefix"/>
          </div>
        </div>
        <div class="row responsive-label">
          <div class="col-sm-12 col-md-3">
            <label for="certZeroPad">Worksheet Zero Pad</label>
          </div>
          <div class="col-sm-12 col-md">
            <input v-model="certZeroPad" type="text" id="certZeroPad"/>
          </div>
        </div>
        <div class="row responsive-label">
          <div class="col-sm-12 col-md-3">
            <label for="serialNumbers">Serial Numbers</label>
          </div>
          <div class="col-sm-12 col-md">
            <textarea v-model="serialNumbers" id="serialNumbers"/>
          </div>
        </div>
      </fieldset>
    </form>
    <button @click="generate">
      Generate Excel
    </button>
  </div>
</template>

<script>
require("@babel/polyfill");
const ExcelJS = require("exceljs/dist/es5/exceljs.browser.js");
const FileSaver = require("file-saver");
const pad = require("pad-left");

export default {
  data() {
    return {
      fileName: "SRC 18_500",
      certPrefix: "SRC 18/500",
      certStart: 1,
      wsPrefix: "Cal Cert 18-",
      certZeroPad: "3",
      serialNumbers: "KA416-1062463"
    };
  },
  methods: {
    downloadFile(url) {
      var req = new XMLHttpRequest();
      req.open("GET", url, true);
      req.responseType = "arraybuffer";

      req.onload = function() {
        const wb = new ExcelJS.Workbook();
        var data = new Uint8Array(req.response);
        wb.xlsx.load(data).then(() => {
          // console.log(wb);
          const template_ws = wb.getWorksheet("Cal Cert Template");
          console.log(template_ws);
          let currentIndex = this.certStart;

          //Split serialNumbers by \r\n
          this.serialNumbers.split("\n").forEach(serial => {
            if (serial === "") return;

            const ws = wb.addWorksheet(
              `${this.wsPrefix}${pad(currentIndex, this.certZeroPad, "0")}`
            );

            ws.model = Object.assign(template_ws.model, {
              mergeCells: template_ws.model.merges,
              name: `${this.wsPrefix}${pad(
                currentIndex,
                this.certZeroPad,
                "0"
              )}`
            });
            ws.getCell("M8").value = `${this.certPrefix}(${currentIndex})`;
            ws.getCell("M29").value = serial;
            currentIndex++;
          });

          wb.xlsx
            .writeBuffer({
              base64: true
            })
            .then(buffer => {
              FileSaver.saveAs(
                new Blob([buffer], { type: "application/octet-stream" }),
                `${this.fileName}.xlsx`
              );
            });
        });

        // console.log(workbook);
        // wb.Sheets["Sheet1"] = XLSX.utils.aoa_to_sheet(this.filteredJSON);
        // // console.log(wb);
      }.bind(this);

      req.send();
    },
    generate() {
      this.downloadFile("/SRC_template_2018.xlsx");
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.responsive-label {
  align-items: center;
}
.responsive-label .col-md-3 {
  text-align: right;
}
.responsive-label .col-md {
  text-align: left;
}
</style>
